/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { LocationDtoModel } from '@well/delivery-libs/location-management/domain';
import { TaskCheckpointViewVoModel } from './task-checkpoint-view-vo.model';
import { TaskState } from './task-state.model';

export class TaskViewVoModel extends JSONable {
  uuid: string | undefined = undefined;
  status: string | undefined = undefined;
  lastModifiedAt: string | undefined = undefined;
  mainDriverName: string | undefined = undefined;
  mainDriverPhoneNumber: string | undefined = undefined;
  secondDriverName: string | undefined = undefined;
  secondDriverPhoneNumber: string | undefined = undefined;
  licensePlate: string | undefined = undefined;
  vehicleType: string | undefined = undefined;
  source: LocationDtoModel | undefined = undefined;
  destination: LocationDtoModel | undefined = undefined;
  sumVolume: number | undefined = undefined;
  pcsNr: number | undefined = undefined;
  sumWeight: number | undefined = undefined;
  series: string | undefined = undefined;
  state: TaskState | undefined = undefined;

  pickupCheckpoint: TaskCheckpointViewVoModel | undefined = undefined;
  deliveryCheckpoints: TaskCheckpointViewVoModel[] = [];
  returnCheckpoint: TaskCheckpointViewVoModel | undefined = undefined;
}
